import { create } from "zustand";

import axios from "../helper/axios";

const useResumeStore = create((set,get) => ({
    resumes: [],
    resumeStats: [],
    selectedQhrids: {},
    resumeAnalysysData : {},
    allApplications:[],
    selectedApplication:null,
    selectedProfileResume:null,
    updateFlag:false,
    updateResumeStatusFlag:false,
    updateInterviewStatusFlag:false,        
    selectedJDMapData:null,
    updateFlagSpecific:false,
    totalapplications: 0,
    reqAllApplications:false,
            
    downloadResumeByID: async (jdID,resumeID) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/users/${userData.qhoid}/jds/${jdID}/resumes/${resumeID}`,
                {
                    responseType : "blob"
                }
            );

            const blob = new Blob([response.data]);

            // Create a temporary anchor element
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
    
            // Specify the filename for the downloaded file
            link.setAttribute('download', 'resume.pdf');
    
            // Append the anchor element to the body
            document.body.appendChild(link);
    
            // Trigger the download
            link.click();
    
            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
        }
    },
    getResumesByJD: async (id) => {
        try {
            console.log("getResumesByJD",id);
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(`/getresumes/${userData.qhoid}/${userData.qhuid}/jds/${id}`);

            console.log("Resumes",response);

            set({ resumes: response?.data });
        } catch (err) {
            console.error(err);
        }
    },
    updateResume: async (jdId, resumeId, body) => {
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        try {
            const formData = new FormData();
            for (let key in body) {
                formData.append(key, body[key]);
            }

            await axios.put(
                `/users/${userData.qhoid}/jds/${jdId}/resumes/${resumeId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data", // Important for handling form data
                    },
                }
            );
        } catch (err) {
            console.error(err);
        }
    },

    getResumeSkill: async (jdid,resumeId) => {
        
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(userData);
            const response = await axios.get(
                `/users/${userData.qhoid}/jds/${jdid}/resumes/${resumeId}/skillmatch`
            );

            set({ resumeAnalysysData: response?.data });
        } catch (err) {
            console.error(err);
        }
    },
    getSpecificApplicationByJD: async (jdid,rid) => {
        try {

           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getapplication/${userData.qhoid}/${userData.qhuid}/jds/${jdid}/${rid}`);

           console.log(response.data.name,jdid,rid );
           console.log("Specific Application Data:", response.data.data);
           set({ selectedApplication: response?.data.data });
        } catch (err) {
            console.error(err);
        }
    },
    getAllApplicationsByJD: async (jdid, filterParams ,  pageNumber , limit ,duration,statustype) => {
    try {
     
      
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //const duration = localStorage.getItem("resumes.duration");
      // Merge user provided filters with defaults
      const finalFilters = { 
        ...filterParams,
        ...(pageNumber && { pageNumber }),
        ...(limit && { limit }),
        ...(statustype && { statustype })
      };
      
      // READ state using get()
      const { reqAllApplications } = get();      
      if(reqAllApplications){
        return;
      }
      set({ reqAllApplications: true });
      const response = await axios.get(
        `/getapplications/${userData.qhoid}/${userData.qhuid}/jds/${jdid}/${duration}`,
        {
          params: finalFilters,
          paramsSerializer: (params) => {
            return Object.entries(params)
              .map(([key, value]) => {
                if (Array.isArray(value)) {
                  return value
                    .map(
                      (v) =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
                    )
                    .join("&");
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(
                  value
                )}`;
              })
              .join("&");
          },
        }
        // axios expects params object inside an options object
      );
      
      console.log("All Applications per page",response?.data.data)
      set({ allApplications: response?.data.data });
      set({ selectedJDMapData: response.data.mapdata });
      set({ resumes: response?.data.resumeData });
      set({ totalapplications: response?.data.totalCount});
      set({ reqAllApplications: false });
    } catch (err) {
      console.error(err);
      set({ reqAllApplications: false });
    }
  },

    updateCandidateStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log("updating candidate status body:", body);
            const response = await axios.post(
                `/candidatestatus/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`,
                body.jasonValues
            );
            set({ updateFlag: true });
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
            set({ updateFlag: false });
        }
    },
    updateResumeStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log("updating resume status body:", body);
            const response = await axios.post(
                `/candidatestatus/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`,
                body.jasonValues
            );
            set({ updateResumeStatusFlag: true });
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
            set({ updateResumeStatusFlag: false });
        }
    },  
    updateInterviewStatus: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log("updating interview status body:", body);
            const response = await axios.post(
                `/candidatestatus/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`,
                body.jasonValues
            );
            set({ updateInterviewStatusFlag: true });
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
            set({ updateInterviewStatusFlag: false });
        }
    },                   
    updateProfileInApplication: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            //console.log(body);
            const response = await axios.post(
                `/updatecandidateprofile/${userData.qhoid}/${userData.qhuid}/jds/${body.jdID}/${body.resumeID}`,
                body.jasonValues
            );
            set({ updateFlagSpecific: true });
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
            set({ updateFlagSpecific: false });
        }
    },
    getProfileResumeDetails: async (jdid,rid) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getcandidateresume/${userData.qhoid}/${userData.qhuid}/jds/${jdid}/${rid}`);
           console.log(response.data.name,jdid,rid);
          // console.log(response.data,rid);
           set({ selectedProfileResume: response?.data.data });
        } catch (err) {
            console.error(err);
        }
    },

    resetSelectedProfileResume: async () => {
        set({ selectedProfileResume: null });
    }, 
    resetSelectedApplication: async () => {
        set({ selectedApplication: null });
    },  
    setUpdateFlag: async () => {
        set({ updateFlag: true });
    },
    setUpdateResumeStatusFlag: async () => {
        set({ updateResumeStatusFlag: true });
    },
    setUpdateInterviewStatusFlag: async () => {
        set({ updateInterviewStatusFlag: true });
    },        
    resetUpdateFlag: async () => {
        set({ updateFlag: false });
    },         
    resetUpdateResumeStatusFlag: async () => {
        set({ updateResumeStatusFlag: false });
    },  
    resetUpdateInterviewStatusFlag: async () => {
        set({ updateInterviewStatusFlag: false });
    },  
    setUpdateFlagSpecific: async () => {
        set({ updateFlagSpecific: true });
    },
    resetUpdateFlagSpecific: async () => {
        set({ updateFlagSpecific: false });
    }, 
    resetReqAllApplications: async () => {
        set({ reqAllApplications: false });
    },           
    CandidateCommunication: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log(body);
            const response = await axios.post(
                `/candidatscommunication/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`,
                body.jasonValues
            );
            set({ updateFlag: true });
            //console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },                        

    handleDownloadAll: async (
        qhjid,
        headers,
        isPivot,
        resumeIds,
        filterParameters = {}
    ) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails") || "{}");
            const mode =
                Array.isArray(resumeIds) && resumeIds.length > 0
                    ? "selected"
                    : "All";

            const response = await axios.post(
                `/applications/${userData.qhoid}/${qhjid}/download`,
                { mode, headers, isPivot, resumeIds },
                {
                    params: filterParameters,
                    paramsSerializer: (params) => {
                        return Object.entries(params)
                            .map(([key, value]) => {
                                if (Array.isArray(value)) {
                                    return value
                                        .map(
                                            (v) =>
                                                `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
                                        )
                                        .join("&");
                                }
                                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                            })
                            .join("&");
                    },
                    responseType: "blob",
                }
            );

            const mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const blob = new Blob([response.data], { type: mimeType });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;

            const now = new Date();
            const pad = (n) => String(n).padStart(2, "0");
            const datePart = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
                now.getDate()
            )}`;
            const timePart = `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(
                now.getSeconds()
            )}`;

            const safeJdId = String(qhjid).toLowerCase();
            link.download = `${safeJdId}_applications_tracker_${datePart}_${timePart}.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    },
    setSelectedQhrids: async (qhrids) => {
        set({ selectedQhrids: qhrids });
    }, 
}));

export default useResumeStore;
